import React, { Component } from 'react';
import { Route, Redirect } from 'react-router-dom';


export class Auth extends Component {

  constructor(props) {
    super(props);
    this.state = {isAuthenticated: false};
  }

  render() {
    const isAuthenticated = !!localStorage.getItem('token');
    console.log(isAuthenticated);
    return (
      isAuthenticated? (
        <Route children={this.props.children}/>
      ) : (
        <Redirect to={'/login'} />
      )
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Auth.jsx